import store from "@/store";
import axios from "axios";

const getUserInfo = async () => {
    const token = store.getters["userAuth/getToken"];
    const config = {
        url: `${process.env.VUE_APP_BASE_API}user/getUser`,
        method: 'POST',
        headers:{
            Authorization: `Bearer ${token}`,
            "Content-Type": `application/json; charset=utf-8`,
        },
        data: {
            uid: store.getters["userAuth/getUsername"]
        }
    };
    const userInfo = await axios(config);
    store.dispatch("userInfo/setStore", userInfo.data[0]);
};

export { getUserInfo as default };